var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgService = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  d: "M9.5 17.5V21L7 23.5H4l-.5-.5L5 21.5l.5-1-2-2-1 .5L1 20.5.5 20v-3L3 14.5h3.5l8-8V3L17 .5h3l.5.5-1.75 1.719-.25.781 2 2 .781-.25L23 3.5l.5.5v3L21 9.5h-3.5z",
  clipRule: "evenodd"
})));
export { SvgService as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOS41IDE3LjVWMjFMNyAyMy41SDRsLS41LS41TDUgMjEuNWwuNS0xLTItMi0xIC41TDEgMjAuNS41IDIwdi0zTDMgMTQuNWgzLjVsOC04VjNMMTcgLjVoM2wuNS41LTEuNzUgMS43MTktLjI1Ljc4MSAyIDIgLjc4MS0uMjVMMjMgMy41bC41LjV2M0wyMSA5LjVoLTMuNWwtOCA4eiIgc3Ryb2tlPSIjZmZmIi8+PC9zdmc+";